import React from "react";
import styled from "styled-components";
import _ from "lodash";

const StyledDiv = styled.div`
  font-size:17px;
  color:#333;
  white-space: pre-line;
  word-break: break-word;
`;
const ViewOnlyDiv = ({ children, placeholder, isIndented, hasBorder }) => {
  if (!placeholder) {
    placeholder = "--";
  }
  if (!children) {
    return <StyledDiv style={{ paddingLeft: "15px", paddingRight: "15px", marginLeft: isIndented ? "55px" : "", borderBottom: hasBorder ? "1px solid gainsboro" : "" }}>{placeholder}</StyledDiv>;
  }

  return <StyledDiv style={{ paddingLeft: "15px", paddingRight: "15px", marginLeft: isIndented ? "55px" : "", borderBottom: hasBorder ? "1px solid gainsboro" : "" }}>{children}</StyledDiv>;
};

export default ViewOnlyDiv;
